import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { NavController, NavParams, App } from 'ionic-angular';
import { UsersPage } from '../users/users';
import { CustomersPage } from '../customers/customers';
import { CardsPage } from '../cards/cards';
import { ScriptLoader } from '../../providers/script-loader';
import { DataTableDirective } from 'angular-datatables';
import { TranslateService } from '@ngx-translate/core';
import { Storage } from '../../../node_modules/@ionic/storage';
import { AuthenticationService } from '../../providers/authentication/authenticationService';
import { MyApp } from '../../app/app.component';
import { NavControllerService } from '../../providers/nav-controller/navControllerService';
import { PoS } from '../../app/models/PoS';
import { PaytronBackendService } from '../../providers/paytron-backend/paytron-backend.service';
import { RegisterActivity } from '../../app/models/RegisterActivity';
import { RegisterActivitiesPage } from '../register-activities/register-activities';
import { SpecialOffersPage } from '../special-offers/special-offers';
import { ProductsPage } from '../products/products';
import { PosPage } from '../pos/pos';
import { PriceListPage } from '../price-list/price-list';
import { TaxRatesPage } from '../taxrates/taxrates';
import { OrganizationPage } from '../organization/organization';
import { CouponTypesPage } from '../coupon-types/coupon-types';
import { PrintsPage } from '../prints/prints';
import { CurrentAccountsPage } from '../current-accounts/current-accounts';
import { PosType } from '../../app/models/PosType';
import { ConfigService } from '../../providers/config/config.service';

@Component({
  selector: 'page-layout',
  templateUrl: 'layout.html',
})
export class LayoutPage implements AfterViewInit {
  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;

  private pageName: string = 'page-layout';
  private elements: any;
  private navControllerService: NavControllerService;
  private closedActivity: boolean;
  private currentPos: PoS;
  private userRole: string;
  private isAuthorizedToUserRelatedPages: boolean;
  private currentActivityUuid: string = '';
  private currentPosUuid: string;
  private posList: PoS[] = [];

  lang = this.translate.getBrowserLang();
  helpHref: string;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public translate: TranslateService,
    private scriptLoader: ScriptLoader,
    private storage: Storage,
    private backendService: PaytronBackendService,
    private authenticationService: AuthenticationService,
    private elem: ElementRef,
    private app: App,
    private myApp: MyApp,
    private configService: ConfigService
  ) {
    this.navControllerService = new NavControllerService(app, storage);
    this.navControllerService.isAuthorizedToUserRelatedPages().then((isAuthorized: boolean) => {
      this.isAuthorizedToUserRelatedPages = isAuthorized;
    });
    this.translate.setDefaultLang('it');
    this.storage.get('lang').then((val) => {
      this.translate.use(val);
    });
    this.storage.get('userRole').then((userRole) => {
      this.userRole = userRole;
    });
    this.storage.get('registerActivity').then((activity: RegisterActivity) => {
      this.currentActivityUuid = activity ? activity.uuid : '';
    });
    this.currentPosUuid = localStorage.getItem('pos');
    this.getLastActivity();
    this.helpHref = configService.getHelpHref();
  }

  switchLanguage(lang: string) {
    this.lang = lang;
    this.storage.set('lang', this.lang);
    this.translate.use(this.lang);
  }

  ngAfterViewInit() {
    this.scriptLoader.loadJS('../../assets/js/sb-admin.min.js', this.callback, document.body);
  }

  callback() {}

  loadJS(url, implementationCode, location) {
    //url is URL of external file, implementationCode is the code
    //to be called from the file, location is the location to
    //insert the <script> element

    var scriptTag = document.createElement('script');
    scriptTag.src = url;

    scriptTag.onload = implementationCode;

    location.appendChild(scriptTag);
  }

  getTypeWebClosedPosList() {
    this.backendService.getClosedPoSList().subscribe((posList: PoS[]) => {
      this.posList = posList.filter(p => p.type.toString() === PosType[PosType.Web]);
    });
  }

  getLastActivity() {
    if (this.currentPosUuid) {
      this.backendService.getLastRegisterActivity(this.currentPosUuid).subscribe((activity) => {
        this.storage.set('registerActivity', activity);
        this.currentPos = activity.pos;
        this.closedActivity = activity.closeDate ? true : false;
        this.posList = [activity.pos];
        this.currentActivityUuid = activity.uuid;
      });
    } else {
      this.closedActivity = true;
      this.getTypeWebClosedPosList();
    }
  }

  operRegisterActivity(pos: PoS) {
    this.backendService.openRegisterActivity(pos).subscribe(
      (activity: RegisterActivity) => {
        this.storage.set('PoS', pos);
        localStorage.setItem('pos', pos.uuid);
        this.storage.set('registerActivity', activity);
        this.currentActivityUuid = activity.uuid;
        this.closedActivity = false;
        this.showRegisterActivitiesPage();
      },
      (err: HttpErrorResponse) => {}
    );
  }

  closeRegisterActivity() {
    this.backendService.closeRegisterActivity(this.currentActivityUuid).subscribe(
      (activity: RegisterActivity) => {
        this.closedActivity = true;
        this.showRegisterActivitiesPage();
      },
      (err: HttpErrorResponse) => {}
    );
  }

  getUsersClass() {
    return this.getSideBarClass(UsersPage);
  }

  getCustomersClass() {
    return this.getSideBarClass(CustomersPage);
  }

  getCardsClass() {
    return this.getSideBarClass(CardsPage);
  }

  getSpecialOffersClass() {
    return this.getSideBarClass(SpecialOffersPage);
  }

  getProductsClass() {
    return this.getSideBarClass(ProductsPage);
  }

  getRegisterActivitiesClass() {
    return this.getSideBarClass(RegisterActivitiesPage);
  }

  getPosClass() {
    return this.getSideBarClass(PosPage);
  }

  getPricelistClass() {
    return this.getSideBarClass(PriceListPage);
  }

  getTaxRatesClass() {
    return this.getSideBarClass(TaxRatesPage);
  }

  getCouponTypesClass() {
    return this.getSideBarClass(CouponTypesPage);
  }

  getOrganizationClass() {
    return this.getSideBarClass(OrganizationPage);
  }

  getPrintsClass() {
    return this.getSideBarClass(PrintsPage);
  }

  getCurrentAccountsClass() {
    return this.getSideBarClass(CurrentAccountsPage);
  }

  getSideBarClass(currentClass) {
    let activePage = this.navCtrl.getActive();
    if (activePage.component.name == currentClass.name) {
      return 'nav-item selected';
    }
    return 'nav-item';
  }

  showUsersPage() {
    this.navControllerService.showUsersPage();
  }

  showCustomersPage() {
    this.navControllerService.showCustomersPage();
  }

  showSpecialOffersPage() {
    this.navControllerService.showSpecialOffersPage();
  }

  showCardsPage() {
    this.navControllerService.showCardsPage();
  }

  showRegisterActivitiesPage() {
    this.navControllerService.showRegisterActivitiesPage();
  }

  showProductsPage() {
    this.navControllerService.showProductsPage();
  }

  showPosPage() {
    this.navControllerService.showPosPage();
  }

  showPriceListPage() {
    this.navControllerService.showPricelistPage();
  }

  showTaxRatesPage() {
    this.navControllerService.showTaxRatesPage();
  }

  showOrganizationPage() {
    this.navControllerService.showOrganizationPage();
  }

  showCouponTypesPage() {
    this.navControllerService.showCouponTypesPage();
  }

  showPrintsPage() {
    this.navControllerService.showPrintsPage();
  }

  showCurrentAccountsPage() {
    this.navControllerService.showCurrentAccountsPage();
  }

  logout() {
    this.authenticationService.logout().subscribe(
      (data) => {
        let currentIndex = this.navCtrl.getActive().index;
        this.navCtrl.push(this.myApp.rootPage).then(() => {
          this.navCtrl.remove(currentIndex);
        });
      },
      (err: HttpErrorResponse) => {
        if (err.status == 401) {
        }
        if (err.status == 0) {
        }
      }
    );
  }

  // onKey($event) {
  //   ;
  //   this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
  //     dtInstance.search($event.key);
  //   })
  // }
}



// WEBPACK FOOTER //
// ./src/pages/layout/layout.ts